<!--历史值 historyValue-->
<template>
  <div class="myhistoryValue">
    <div class="con" style="background-color: #eee;">
      <div class="tree-left" style="height:calc(100vh - 152px);">
        <elUnitTree @checkFun="checkFun" :dataList="virtualDeviceList"></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%;">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <span style="width: 60px;">应用类型</span>
              <elUnitTree2 @checkFun="checkFun2"> </elUnitTree2>
              <div class="input-small mr-20">
                <span>日期：</span>
                <el-date-picker value-format="timestamp" v-model="datetimeValue" type="daterange"
                  :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期"></el-date-picker>
              </div>
              <div class="input-small myinput">
                <span>间隔(分钟)：</span>
                <el-select v-model="timeInterval" placeholder="请选择" class="eSel" @change="aaa">
                  <el-option v-for="item in times" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
              <el-button @click="mysearch" type="primary" plain class="search-btn">查询</el-button>
            </div>
          </el-scrollbar>
        </div>
        <div class="mytable" id="region-cost">
          <el-table :data="nowPage" :max-height="heights" border style="width: 100%;">
            <el-table-column label="序号" width="50" align="center" fixed>
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据" />
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="deviceName" label="变量名" width="260" fixed>
            </el-table-column>
            <el-table-column prop="dateTimer" label="日期" width="180">
            </el-table-column>
            <el-table-column prop="currentValue" label="最大值" width="90">
            </el-table-column>
            <el-table-column prop="currentValue" label="最小值" width="90">
            </el-table-column>
            <el-table-column prop="valueUnit" label="单位" width="90" align="center">
            </el-table-column>
            <el-table-column v-for="(e, i) in coloms" :key="i" prop="currentValue" :label="e"
              :width="e == 'variablename' ? 260 : 90" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>
  </div>
</template>

<script type="text/javascript">
import elUnitTree from "@/components/module/newTree/elUnitTree.vue";
import downloadTable from "@/components/module/downloadTable/downloadTable.vue";
import request from "@/api/http.js";
import elUnitTree2 from "@/components/module/newTree/elUnitTree2.vue";
import { parseTime } from "@/utils";
export default {
  components: {
    elUnitTree,
    downloadTable,
    elUnitTree2,
  },
  props: [],
  data() {
    return {
      a: [
        "电流",
        "相电压",
        "有功电能",
        "有功功率",
        "频率",
        "温度",
        "功率因数",
        "无功功率",
        "线电压",
        "未定义"
      ],
      b: [{ label: "C1FB-G01-C3FA出线柜" }],
      shouMenu: false,
      shouMenu2: false,
      all: [], //总no数据
      flag: false,
      nowPage: [],
      deviceNos: [],
      dataed: [],
      dataed_un: [],
      defaultProps: "",
      heights: Math.round(document.getElementById("app").clientHeight * 0.79),
      dataList: [],
      coloms: [],
      newcoloms: [],
      list2: [],
      flag: true,
      nowVirtualDevice: undefined,
      apptypeValue: [],
      nowApptypeGroups: [],
      checkVariablename: [], //需要显示的变量名称
      timeToValue: {}, //变量名+年+月+日:288个数据
      timeInterval: 30, //时间间隔,单位是分钟
      mytimeInterval: 30, //时间间隔,单位是分钟
      totalSize: 0,
      pageLen: 48,
      nowIndex: 0,
      from2name: {},
      datetimeValue: [],
      // new Date(new Date().toLocaleDateString()).getTime(),new Date().getTime()
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date(new Date().toLocaleDateString());
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date(new Date().toLocaleDateString());
              const start = new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      times: [5, 15, 30, 60],
      arr15: [],
      arr30: [],
      arr60: [],
      colomsCopy: [],
      nowDevice: [],
      nowVirtualDeviceList: [],
      loading: false, //页面加载
      mynum: 1,
      copydevice: [],
      zongquanxuan: [],
      quanxuanlen: 0,
      quxuanFlag: false,
      newmynum: 1,
    };
  },
  mounted() {
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    var timestamp = now.getTime();
    this.datetimeValue = [timestamp, new Date().getTime()];
    this.colomsFn();
  },
  computed: {
    variableStore() {
      return this.$store.variableStore;
    },
    deviceStore() {
      return this.$store.deviceStore;
    },
    variableTree() {
      if (isempty(this.nowVirtualDeviceList)) {
        return [];
      }
      var variableTreeArr = [];
      this.nowVirtualDeviceList.forEach((item) => {
        var variableTree = [];
        if (item.type == "virtualDevice") {
          if (variableTree.length == 0) {
            variableTree = this.variableStore.getters.getVariableTree(item.no);
          }
        }
        variableTree.forEach((tree) => {
          tree.devicename = item.name;
        });
        variableTreeArr.push(variableTree);
      });
      var result = [];
      variableTreeArr.forEach((item) => {
        result = result.concat(item);
      });
      return result;
    },
    apptypeGroups() {
      //所有已选中的设备所具有的变量类型组
      var list = [];
      var apptypeGroupIds = [];
      this.variableTree.forEach((apptypeGroup) => {
        if (!apptypeGroupIds.includes(apptypeGroup.id)) {
          if (apptypeGroup.name.indexOf("未定义") == -1) {
            apptypeGroupIds.push(apptypeGroup.id);
            list.push(apptypeGroup);
          }
        }
      });
      //排序
      list.sort((a, b) => {
        return a.serialnum - b.serialnum;
      });
      let idList = [];
      list.forEach((item) => {
        idList.push(item.id);
      });
      this.quanxuanlen = idList.length;
      this.zongquanxuan = idList;
      if (!this.quxuanFlag) {
        this.apptypeValue = this.apptypeValue.filter(function (element) {
          return idList.includes(element);
        });
      }
      if (this.mynum < 3) {
        var myarr = list.filter((item) => item.name == "有功电能");
        if (myarr.length == 0) {
          if (list.length != 0) {
            this.apptypeValue = [list[0].id];
          }
        } else {
          this.apptypeValue = [myarr[0].id];
        }
        this.mynum += 1;
      }
      return list;
    },
    apptypes() {
      //当前选中的这些变量类型组下面的变量类型列表
      var list = [];
      this.apptypeGroups.forEach((item) => {
        list = list.concat(
          this.variableStore.getters.getApptypeByGroupId(item.id)
        );
      });
      return list;
    },

    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
    },
    nowSelectAppTypeGroupIds() {
      return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(
        this.apptypeGroups
      );
    },
  },
  watch: {

  },
  methods: {
    aaa(v) {
      if (v == 5) {
        this.coloms = JSON.parse(JSON.stringify(this.colomsCopy));
      } else if (v == 15) {
        this.coloms = this.arr15;
      } else if (v == 30) {
        this.coloms = this.arr30;
      } else if (v == 60) {
        this.coloms = this.arr60;
      }
    },
    mysearch() {
      if (this.timeInterval == 5) {
        this.coloms = JSON.parse(JSON.stringify(this.colomsCopy));
      } else if (this.timeInterval == 15) {
        this.coloms = this.arr15;
      } else if (this.timeInterval == 30) {
        this.coloms = this.arr30;
      } else if (this.timeInterval == 60) {
        this.coloms = this.arr60;
      }

      this.nowPage = [];
      this.b.map((v) => {
        this.a.map((a) => {
          this.nowPage.push({
            deviceName: v.label + '.' + a,
            variableName: a,
            dateTimer: parseTime(this.datetimeValue[0], '{y}-{m}-{d}'),
            currentValue: Math.round(Math.random() * 333),
            valueUnit: "A",
            changeTime: "2022-10-17 11:36:00",
            status: 0,
          });
        });
      });
      console.log(this.nowPage)
    },
    checkFun2(v) {
      this.a = v;
      this.mysearch();
    },
    checkFun(val) {
      this.b = val;
      this.mysearch();
    },
    // 应用类型->修改应用类型参与查询状态
    updateEnableStatus(data) {
      var params = {
        deviceNos: data.join(","),
      };
      // /variable/findAppTypeByDeviceNo

    },

    // 过滤数据
    listFilter(v) {
      var d = []; //数据
      var coloms = []; //键
      var str = "";
      v.map((a) => {
        a.energyHistory.map((b, i) => {
          b.issueValues.map((c) => {
            var colomData = {};
            for (const key in c) {
              if (key.includes("value") && key != "valueUnit") {
                str = key.substring(5, 7) + " : " + key.substring(7, 9);
                colomData[str] = c[key] == -1.1111 ? "" : c[key];
              } else {
                colomData[key] = c[key] == -1.1111 ? "" : c[key];
              }
              if (!d.length) {
                if (key.includes("value") && key != "valueUnit") {
                  str = key.substring(5, 7) + " : " + key.substring(7, 9);
                  // coloms.push(str)
                }
              }
            }
            colomData.dateTimer = b.selectTime;
            d.push(colomData);
          });
          // d[i].dateTimer=b.selectTime
        });
      });

      this.dataList = d;
      this.loading = false;
    },
    // 过滤键方法
    colomsFn() {
      this.colomsCopy = [
        "00 : 00",
        "00 : 05",
        "00 : 10",
        "00 : 15",
        "00 : 20",
        "00 : 25",
        "00 : 30",
        "00 : 35",
        "00 : 40",
        "00 : 45",
        "00 : 50",
        "00 : 55",
        "01 : 00",
        "01 : 05",
        "01 : 10",
        "01 : 15",
        "01 : 20",
        "01 : 25",
        "01 : 30",
        "01 : 35",
        "01 : 40",
        "01 : 45",
        "01 : 50",
        "01 : 55",
        "02 : 00",
        "02 : 05",
        "02 : 10",
        "02 : 15",
        "02 : 20",
        "02 : 25",
        "02 : 30",
        "02 : 35",
        "02 : 40",
        "02 : 45",
        "02 : 50",
        "02 : 55",
        "03 : 00",
        "03 : 05",
        "03 : 10",
        "03 : 15",
        "03 : 20",
        "03 : 25",
        "03 : 30",
        "03 : 35",
        "03 : 40",
        "03 : 45",
        "03 : 50",
        "03 : 55",
        "04 : 00",
        "04 : 05",
        "04 : 10",
        "04 : 15",
        "04 : 20",
        "04 : 25",
        "04 : 30",
        "04 : 35",
        "04 : 40",
        "04 : 45",
        "04 : 50",
        "04 : 55",
        "05 : 00",
        "05 : 05",
        "05 : 10",
        "05 : 15",
        "05 : 20",
        "05 : 25",
        "05 : 30",
        "05 : 35",
        "05 : 40",
        "05 : 45",
        "05 : 50",
        "05 : 55",
        "06 : 00",
        "06 : 05",
        "06 : 10",
        "06 : 15",
        "06 : 20",
        "06 : 25",
        "06 : 30",
        "06 : 35",
        "06 : 40",
        "06 : 45",
        "06 : 50",
        "06 : 55",
        "07 : 00",
        "07 : 05",
        "07 : 10",
        "07 : 15",
        "07 : 20",
        "07 : 25",
        "07 : 30",
        "07 : 35",
        "07 : 40",
        "07 : 45",
        "07 : 50",
        "07 : 55",
        "08 : 00",
        "08 : 05",
        "08 : 10",
        "08 : 15",
        "08 : 20",
        "08 : 25",
        "08 : 30",
        "08 : 35",
        "08 : 40",
        "08 : 45",
        "08 : 50",
        "08 : 55",
        "09 : 00",
        "09 : 05",
        "09 : 10",
        "09 : 15",
        "09 : 20",
        "09 : 25",
        "09 : 30",
        "09 : 35",
        "09 : 40",
        "09 : 45",
        "09 : 50",
        "09 : 55",
        "10 : 00",
        "10 : 05",
        "10 : 10",
        "10 : 15",
        "10 : 20",
        "10 : 25",
        "10 : 30",
        "10 : 35",
        "10 : 40",
        "10 : 45",
        "10 : 50",
        "10 : 55",
        "11 : 00",
        "11 : 05",
        "11 : 10",
        "11 : 15",
        "11 : 20",
        "11 : 25",
        "11 : 30",
        "11 : 35",
        "11 : 40",
        "11 : 45",
        "11 : 50",
        "11 : 55",
        "12 : 00",
        "12 : 05",
        "12 : 10",
        "12 : 15",
        "12 : 20",
        "12 : 25",
        "12 : 30",
        "12 : 35",
        "12 : 40",
        "12 : 45",
        "12 : 50",
        "12 : 55",
        "13 : 00",
        "13 : 05",
        "13 : 10",
        "13 : 15",
        "13 : 20",
        "13 : 25",
        "13 : 30",
        "13 : 35",
        "13 : 40",
        "13 : 45",
        "13 : 50",
        "13 : 55",
        "14 : 00",
        "14 : 05",
        "14 : 10",
        "14 : 15",
        "14 : 20",
        "14 : 25",
        "14 : 30",
        "14 : 35",
        "14 : 40",
        "14 : 45",
        "14 : 50",
        "14 : 55",
        "15 : 00",
        "15 : 05",
        "15 : 10",
        "15 : 15",
        "15 : 20",
        "15 : 25",
        "15 : 30",
        "15 : 35",
        "15 : 40",
        "15 : 45",
        "15 : 50",
        "15 : 55",
        "16 : 00",
        "16 : 05",
        "16 : 10",
        "16 : 15",
        "16 : 20",
        "16 : 25",
        "16 : 30",
        "16 : 35",
        "16 : 40",
        "16 : 45",
        "16 : 50",
        "16 : 55",
        "17 : 00",
        "17 : 05",
        "17 : 10",
        "17 : 15",
        "17 : 20",
        "17 : 25",
        "17 : 30",
        "17 : 35",
        "17 : 40",
        "17 : 45",
        "17 : 50",
        "17 : 55",
        "18 : 00",
        "18 : 05",
        "18 : 10",
        "18 : 15",
        "18 : 20",
        "18 : 25",
        "18 : 30",
        "18 : 35",
        "18 : 40",
        "18 : 45",
        "18 : 50",
        "18 : 55",
        "19 : 00",
        "19 : 05",
        "19 : 10",
        "19 : 15",
        "19 : 20",
        "19 : 25",
        "19 : 30",
        "19 : 35",
        "19 : 40",
        "19 : 45",
        "19 : 50",
        "19 : 55",
        "20 : 00",
        "20 : 05",
        "20 : 10",
        "20 : 15",
        "20 : 20",
        "20 : 25",
        "20 : 30",
        "20 : 35",
        "20 : 40",
        "20 : 45",
        "20 : 50",
        "20 : 55",
        "21 : 00",
        "21 : 05",
        "21 : 10",
        "21 : 15",
        "21 : 20",
        "21 : 25",
        "21 : 30",
        "21 : 35",
        "21 : 40",
        "21 : 45",
        "21 : 50",
        "21 : 55",
        "22 : 00",
        "22 : 05",
        "22 : 10",
        "22 : 15",
        "22 : 20",
        "22 : 25",
        "22 : 30",
        "22 : 35",
        "22 : 40",
        "22 : 45",
        "22 : 50",
        "22 : 55",
        "23 : 00",
        "23 : 05",
        "23 : 10",
        "23 : 15",
        "23 : 20",
        "23 : 25",
        "23 : 30",
        "23 : 35",
        "23 : 40",
        "23 : 45",
        "23 : 50",
        "23 : 55",
      ];
      var str = "";
      this.arr15 = [];
      this.arr30 = [];
      this.arr60 = [];
      //  this.coloms=JSON.parse(JSON.stringify(this.colomsCopy));
      this.colomsCopy.forEach((item) => {
        str = item.substring(5, 7);
        if (str == "00" || str == "15" || str == "30" || str == "45") {
          this.arr15.push(item);
        }
        if (str == "00" || str == "30") {
          this.arr30.push(item);
        }
        if (str == "00") {
          this.arr60.push(item);
        }
      });
      // this.timeInterval_fn(this.timeInterval)
      // this.coloms = this.newcoloms
      this.mysearch();
    },

    exportButton() {
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();

      const tHeader = [
        "查询时间",
        this.date_format_fn(this.datetimeValue[0]) +
        "-" +
        this.date_format_fn(this.datetimeValue[1]),
        "间隔(分钟)",
        this.timeInterval,
      ];
      this.$refs.downloadTable.export2Excel(
        tHeader,
        this.dataList,
        year + "-" + month + "-" + day + "-历史列表",
        "#region-cost"
      );
    },

    selectInterval(interval) {
      this.timeInterval = interval;
    },
    // 转换时间戳
    date_format_fn(value) {
      if (!value) {
        return "";
      }
      let date = new Date(value);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let strDate = Y + M + D;
      return `'${strDate}'`;
    },
  },
};
</script>
<style>
.eSel input {
  width: 80px;
}
</style>
<style scoped lang="scss">
.eSel {
  width: 80px;
  overflow: hidden;
}

.myhistoryValue {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    // 正常
    .patrol {
      p {
        width: 8px;
        height: 8px;
        background-color: #0dae88;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #0dae88;
      }
    }

    // 非正常
    .rush {
      p {
        width: 8px;
        height: 8px;
        background-color: #ff1d1d;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #ff1d1d;
      }
    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
    }

    .tree-left {
      width: 300px;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button+.el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }
    }

    .right-table {
      width: calc(100% - 308px);
      // height: 100%;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;

      .mycharts {
        display: flex;

        .charts-left {
          width: 35%;
        }

        .charts-right {
          width: 70%;
        }
      }
    }
  }
}
</style>
<style scoped>
.block {
  width: 20px;
  height: 20px;
  background-color: #d9d9d9;
  cursor: pointer;
  margin-left: 10px;
}

.unitMenu {
  max-width: 4rem;
  top: 7px;
  margin-left: 78px;
  padding-top: 0.5rem;
  position: absolute;
  z-index: 99999;
}

.unitMenu .elUnitTreeBody {
  width: 2.4rem;
}

.unitMenu .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.cropper-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ul {
  padding: 0 15px;
}

.ul .li {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
}

.ul .li .r {
  color: #378cd4;
  cursor: pointer;
}

.btns {
  width: 300px;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #d7d7d7;
  margin: 0 15px;
}

.color-span {
  display: inline-block;
  width: 15px;
  height: 15px;
  transform: translate(5px, 2px);
  color: #1a1a1a;
}

.user-arrow {
  width: 20px;
  height: 20px;
}

.tongyi-img {
  width: 20px;
  height: 20px;
}

.arrow-active {
  transform: rotateZ(180deg);
}

.topMenu {
  height: 0.5rem;
  overflow-y: hidden;
  /* overflow: hidden; */
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.nowUnit-name {
  margin-left: 0.2rem;
  width: 100px;
  height: 30px;
  border: 1px solid #ccc;
  text-align: left;
  line-height: 30px;
  padding: 0px 12px;
  /* margin-left: 5px; */
  border-radius: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nowUnit-name span {
  color: #666666;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.nowUnit-name img {
  width: 18px;
  height: 18px;
  transition: 0.5s;
}

.nowUnit-active {
  border: 1px solid #409eff;
}

.nowUnit-active1 {
  border: 1px solid #fff;
}

.nowUnit-active img {
  transform: rotateZ(180deg);
}

.nowUnit-active1 img {
  transform: rotateZ(180deg);
}

/* 需要转化 */
.tags-view-container {
  height: 34px;
  width: calc(100% - 2rem);
  position: absolute;
  top: 48px;
  left: 200px;
  /* margin-left: 200px; */
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
  z-index: 999;
}

.tags-view-container .content {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
}

.sidebar-logo {
  width: 32px;
  height: 32px;
  vertical-align: middle;
}

.sidebar-title {
  display: inline-block;
  margin: 0;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  vertical-align: middle;
  margin-left: 10px;
}

/* 需要转化结束 */

.userName {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #1a1a1a;
}

.webTitle {
  height: 0.5rem;
  width: auto;
  text-align: center;
  line-height: 0.5rem;
  font-size: 21px;
  font-weight: bold;
  width: 500px;
  color: #212529;
}

.leftPart {
  /* width: calc(50% - 150px); */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* background-color: #2b2f3a; */
  /* background-color: #fff; */
}

.leftPart-logo {
  width: 2rem;
  height: 0.5rem;
  box-sizing: border-box;
  padding: 9px;
  /* background-color: #304156; */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.35s;
  flex-shrink: 0;
}

.leftPart-logo-active {
  width: 0.8rem;
}

.logo {
  max-width: 185px;
  max-height: 40px;
}

.rightPart {
  /* width: calc(50% - 50px); */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.leftPartImg {
  height: 48px;
  display: flex;
  align-items: center;
  width: 50px;
  /*border-bottom: 2px solid #116af0;*/
}

.rightPart .user {
  /* width: auto; */
  margin-left: 10px;
  max-width: 2rem;
  min-width: 0.2rem;
  /* height: .2rem; */
}

.rightPart .userSelect {
  cursor: pointer;
  width: auto;
  max-width: 2rem;
  min-width: 0.08rem;
  height: 0.06rem;
  margin-right: 20px;
  margin-top: 11px;
}

.unitSelect {
  /* min-width: 1rem; */
  height: 100%;
  /*border-bottom: 2px solid #cce1ff;*/
  height: 48px;
}

.unitSelect>div>input {
  width: 150px;
  background: rgba(0, 0, 0, 0);
  border: 0;
  /* border-left: 1px #49649c solid; */
  border: 1px solid #dcdfe6;
  border-radius: 0;
  padding: 5px 10px;
  height: 20px;
  line-height: 20px;
  outline: none;
  margin: 0 10px;
  color: white;
}

.userMenu {
  padding-top: 0.5rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 9999;
}

.area-tree {
  position: absolute;
  max-width: 2.5rem;
  height: 4rem;
  /* margin-left: 4rem; */
  /* top: 0; */
  top: 0;
  /* right: 0px; */
  margin-left: 19px;
  padding-top: 0.5rem;
  z-index: 99999;
  width: 77%;
}

.area-tree .elUnitTreeBody {
  width: 2.4rem;
}

.area-tree .readDeviceTreeBody {
  border-width: 1px;
  border-style: solid;
  border-radius: 0 0 10px 10px;
}

.menuItem {
  height: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.05rem 0.1rem;
  width: auto;
  cursor: pointer;
  background: white;
  border-left: solid 0.01rem #babec2;
  border-right: solid 0.01rem #babec2;
  border-bottom: solid 0.01rem #babec2;
}

.menuItem:last-child {
  border-radius: 0 0 0.05rem 0.05rem;
}

.menuItem>span {
  text-align: left;
  width: 0.7rem;
  padding-left: 0.1rem;
}

.tool-class {
  width: 50%;
}

.nowTimeBox {
  /*border-bottom: 2px solid #cce1ff;*/
  height: 48px;
  /* color: white; */
  color: #666666;
  line-height: 50px;
  margin-right: 10px;
}

.msgDialog {
  position: absolute;
  width: 360px;
  height: 440px;
  background: white;
  z-index: 5;
  top: 50px;
  right: 20px;
  border-radius: 5px;
  border: 1px silver solid;
  z-index: 110;
}

.msgDialog>p {
  padding-right: 20px;
  line-height: 40px;
  text-align: right;
  border-bottom: 1px silver solid;
  color: #0092dc;
}

/* 修改默认列表样式 */

.msgDialog>>>ul.list-body {
  border-radius: 0;
}

.msgDialog>>>ul.list-body>li {
  padding: 0;
  border-bottom: none;
  background: none;
  cursor: default;
}

.msgOperate {
  overflow: hidden;
  padding: 0 24px;
  border-bottom: solid 1px #cccccc;
}

.msgOperate>button {
  height: 20px;
  box-sizing: border-box;
  margin: 8px 12px;
  color: #0f87db;
  padding: 0 8px;
  background: #ffffff;
  outline: none;
  border: solid 1px #ffffff;
  border-radius: 10px;
  cursor: pointer;
}

.msgOperate>.isFilter {
  border-color: #0f87db;
}

.isFilter {
  color: #0f87db;
  background: none;
}

.msgOperate>span {
  float: right;
  line-height: 36px;
}

.filterDialog {
  position: absolute;
  height: 300px;
  width: 250px;
  background: white;
  top: 50px;
  z-index: 100;
}

.unitName {
  max-width: 140px;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.existMsg {
  position: absolute;
  left: 5px;
  top: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: red;
  color: #ffffff;
  font-size: 0.12rem;
  text-align: center;
  line-height: 20px;
  transform: scale(0.6);
}

.unreadMsgInfo {
  padding: 10px 24px 0 24px;
}

.unreadHead {
  margin-bottom: 6px;
  overflow: hidden;
}

.msgTypeName {
  float: left;
  background: #0582da;
  line-height: 18px;
  padding: 0 8px;
  border-radius: 8px;
  font-size: 0.12rem;
  color: #ffffff;
}

.msgMarkBtn {
  float: right;
  height: 18px;
  box-sizing: border-box;
  border: solid 1px #0f87db;
  border-radius: 8px;
  font-size: 0.12rem;
  padding: 0 8px;
  line-height: 16px;
  color: #0f87db;
  background: #ffffff;
  cursor: pointer;
}

.msgTimeText {
  float: right;
  line-height: 18px;
  font-size: 0.12rem;
  color: #0f87db;
}

.msgIntro {
  font-size: 0.12rem;
  text-indent: 2em;
  padding-bottom: 10px;
  border-bottom: solid 1px #cccccc;
  white-space: normal;
}

.unReadMsg {
  background-color: #e3ebf1;
}
</style>